import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation } from "swiper/modules";
import 'swiper/css/bundle'; 
import { useEffect, useState } from 'react';
import { APIURL, STORAGEURL } from '../..';
import axios from 'axios';  

const Galerie = () => {
    const [data, setData] = useState({});
    const [slidesNum, setSlidesNum] = useState(1);

    const getGallery = async () => {
        const response = await axios.post(APIURL + "/collection/items", {
            type: 'gallery',
            orderAsc: "ASC", 
            limit: 30, 
            page: 1,
            language: 'cs'
        });
        setData(response.data.body);
    };

    // funkce pro počet slidů podle šířky okna
    const updateSlidesNum = () => {
        const width = window.innerWidth;
        if (width > 2000) setSlidesNum(4);
        else if (width > 1200) setSlidesNum(3);
        else if (width > 800) setSlidesNum(2);
        else setSlidesNum(1);
    };

    useEffect(() => {
        getGallery();
        updateSlidesNum();
        window.addEventListener('resize', updateSlidesNum);
        return () => window.removeEventListener('resize', updateSlidesNum);
    }, []);

    return (
        <section className="gallery">
            <Swiper
                modules={[Autoplay, Navigation]}
                autoplay={{ delay: 5000 }}
                loop={true}
                navigation={true}
                slidesPerView={slidesNum}
            > 
                {data?.items?.map((g, i) => (
                    <SwiperSlide key={i}>
                        <div
                            className="slide-bg"
                            style={{ backgroundImage: `url(${STORAGEURL + g.foto})` }}
                        ></div>
                    </SwiperSlide>  
                ))}  
            </Swiper>
        </section>
    );
}

export default Galerie;